// Employment status
export const EMPLOYMENT_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  ON_LEAVE: 'ON_LEAVE',
  TERMINATED: 'TERMINATED',
  PENDING_START: 'PENDING_START',
} as const;

export const EMPLOYMENT_STATUS_LABELS: Record<keyof typeof EMPLOYMENT_STATUS, string> = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  ON_LEAVE: 'On Leave',
  TERMINATED: 'Terminated',
  PENDING_START: 'Pending Start',
};

// Employment type
export const EMPLOYMENT_TYPE = {
  FULL_TIME: 'FULL_TIME',
  PART_TIME: 'PART_TIME',
  CONTRACTOR: 'CONTRACTOR',
  INTERN: 'INTERN',
  TEMPORARY: 'TEMPORARY',
} as const;

export const EMPLOYMENT_TYPE_LABELS: Record<keyof typeof EMPLOYMENT_TYPE, string> = {
  FULL_TIME: 'Full-Time',
  PART_TIME: 'Part-Time',
  CONTRACTOR: 'Contractor',
  INTERN: 'Intern',
  TEMPORARY: 'Temporary',
};

// General status
export const STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;

// Tenant status
export const TENANT_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SUSPENDED: 'SUSPENDED',
  PENDING_SETUP: 'PENDING_SETUP',
} as const;

// User status
export const USER_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SUSPENDED: 'SUSPENDED',
  PENDING_VERIFICATION: 'PENDING_VERIFICATION',
} as const;

// Pay frequency
export const PAY_FREQUENCY = {
  WEEKLY: 'WEEKLY',
  BI_WEEKLY: 'BI_WEEKLY',
  SEMI_MONTHLY: 'SEMI_MONTHLY',
  MONTHLY: 'MONTHLY',
  ANNUALLY: 'ANNUALLY',
} as const;

export const PAY_FREQUENCY_LABELS: Record<keyof typeof PAY_FREQUENCY, string> = {
  WEEKLY: 'Weekly',
  BI_WEEKLY: 'Bi-Weekly',
  SEMI_MONTHLY: 'Semi-Monthly',
  MONTHLY: 'Monthly',
  ANNUALLY: 'Annually',
};

// Location type
export const LOCATION_TYPE = {
  HEADQUARTERS: 'HEADQUARTERS',
  OFFICE: 'OFFICE',
  REMOTE: 'REMOTE',
  WAREHOUSE: 'WAREHOUSE',
  OTHER: 'OTHER',
} as const;

export const LOCATION_TYPE_LABELS: Record<keyof typeof LOCATION_TYPE, string> = {
  HEADQUARTERS: 'Headquarters',
  OFFICE: 'Office',
  REMOTE: 'Remote',
  WAREHOUSE: 'Warehouse',
  OTHER: 'Other',
};

// FLSA status
export const FLSA_STATUS = {
  EXEMPT: 'EXEMPT',
  NON_EXEMPT: 'NON_EXEMPT',
} as const;

export const FLSA_STATUS_LABELS: Record<keyof typeof FLSA_STATUS, string> = {
  EXEMPT: 'Exempt',
  NON_EXEMPT: 'Non-Exempt',
};
